import React from 'react';
import { useTheme } from '../lib/theme-provider';

interface ThemedBackgroundProps {
  pageName: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export function ThemedBackground({ pageName, children, className = '', style }: ThemedBackgroundProps) {
  const { theme } = useTheme();
  
  // 获取对应页面的背景配置
  const bgImageKey = `bg-${pageName}` as keyof typeof theme.images;
  const bgImage = theme.images && theme.images[bgImageKey] ? theme.images[bgImageKey] : null;
  
  // 构建 fallback 的 CSS 渐变（从当前设计提取）
  const getFallbackGradient = () => {
    switch (pageName) {
      case 'home':
        return 'linear-gradient(180deg, #1A0F2A 0%, #120A2A 100%)';
      case 'voice-host':
        return 'linear-gradient(180deg, #1A0F2A 0%, #1F1535 100%)';
      case 'game-stats':
        return 'linear-gradient(180deg, #1A0F2A 0%, #120A2A 100%)';
      default:
        return 'linear-gradient(180deg, #1A0F2A 0%, #120A2A 100%)';
    }
  };
  
  const backgroundImage = bgImage 
    ? `url(${bgImage})` 
    : getFallbackGradient();

  return (
    <div
      className={`w-full ${className}`}
      style={{
        backgroundImage,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        transition: 'background-image 0.3s ease',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
